import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-sm-8 flex middle-xs" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "regular black" }
const _hoisted_4 = {
  key: 0,
  class: "regular transparent-grey"
}

import { computed, PropType, ref } from 'vue';
  import { Suggest } from 'types';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestComponent',
  props: {
    suggest: {
      type: Object as PropType<Suggest.Suggest<Suggest.TypedSuggest>>,
      required: true,
    },
  },
  emits: ['action', 'mouseover'],
  setup(__props, { expose, emit }) {

const props = __props

  

  const suggestRef = ref<HTMLDivElement>(null);

  

  const onClick = () => {
    emit('action', props.suggest);
  };

  const getIcon = computed<string>(() => {
    switch (props.suggest.locationType) {
      case Suggest.LocationType.HOTEL:
        return require('@/assets/img/city.svg');
      case Suggest.LocationType.CITY:
        return require('@/assets/img/map-marker.svg');
      case Suggest.LocationType.AIRPORT:
        return require('@/assets/img/ic-iata.svg');
      default:
        return require('@/assets/img/map-marker.svg');
    }
  });

  const handleMouseOver = () => {
    emit('mouseover');
  };

  expose({
    suggestRef,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "suggestRef",
    ref: suggestRef,
    class: "suggest row between-xs",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick())),
    onMouseover: handleMouseOver
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(getIcon),
        alt: "FinalPrice"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.suggest.title), 1),
        (__props.suggest.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.suggest.subtitle), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 544))
}
}

})